import(/* webpackMode: "eager" */ "/vercel/path0/app/(routes)/alumni/page.jsx");
